import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieManagementService } from "../../account/services/cookie-management.service";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfig } from '../../config-service/app.config';
import { transactionRequestServiceResModel } from '../models/transactionRequestResponse.model';
import { VersionHelper } from '../../utility-packages/versionHelper/version-helper';

@Injectable()
export class TransactionRequestService {
  accessToken = '';

  constructor(private http: HttpClient, private translate: TranslateService, private cookieManagementService: CookieManagementService, private versionHelper: VersionHelper) {

  }

  public transactionRequestResult(alias: string, paymentType: string, type: string, transactionType: string): Observable<transactionRequestServiceResModel> {
    this.accessToken = this.cookieManagementService.getAccessToken();
    if (this.accessToken == '') {
      console.log("Giriş Yapınız!!!");
      return new Observable();
    } else {
      this.accessToken = "Bearer " + this.accessToken;
      let headers = new HttpHeaders({
        'Authorization': this.accessToken
      });
      let body = {
        alias: alias,
        payment_type: paymentType,
        type: type,
        transaction_type: transactionType
      };

      let url =
        AppConfig.settings.apiServer.url +
        'api/transaction/request?region=' +
        AppConfig.settings.city.region +
        '&version=' +
        this.versionHelper.getVersion() +
        '&lang=' +
        AppConfig.settings.apiServer.lang +
        '&authType=' +
        AppConfig.settings.apiServer.authType +
        '&accuracy=0';

      return this.http.post<transactionRequestServiceResModel>(url, body, {
        headers: headers,
        responseType: 'json',
      })
        .pipe(
          catchError((error) => {
            if (typeof error === 'string') {
              return throwError(error);
            } else {
              return throwError(this.translate.instant('DEFAULT_ERROR_MESSAGE'));
            }
          })
        );
    }

  }
}

// curl --request POST \
//   --url 'https://service.kentkart.com/rl1//api/transaction/request?region=028&version=IOS_1.0.0_10.3&authType=4&accuracy=0&lang=tr' \
//   --header 'Authorization: Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJrZW50a2FydC5jb20iLCJzdWIiOiIyMTQxMiIsImF1ZCI6InZGSkhTIiwiZXhwIjoxNjE2ODgxODkyLCJuYmYiOjE2MTYyNzcwOTIsImlhdCI6MTYxNjI3NzA5MiwianRpIjoiNWE4NjI4ZTItM2M4ZS00M2RiLTk0ZWItMzM1NDVjYWMwMWE2Iiwic2NvcGVzIjpbXX0.M5IaALaL5aSQfVj6GsgglqeAyM9sTSLK-JtrBK1P0i3YBVzN61Vv3heSIrhf3Tw0ZeDtlVFwS6xCvMUegvgmsMsnVDaU5Orla8lBSvxgPtj7735ia4k0D2-3HhbOs80vDHf9x8V-VfKXqZt_1K-qrk3KKKw8RT7IqI9mvuK-3Zg' \
//   --header 'Content-Type: multipart/form-data; boundary=---011000010111000001101001' \
//   --cookie connect.sid=s%253A1P9afP81x0R2dXzRyKJl5e-6IyyrroAs.3Vz77xEavemBiwnW%252Fa8JB8lyOU1VrI%252FIdVj4bwjuS4k \
//   --form alias=0141155271 \
//   --form payment_type=1 \
//   --form type=2 \
//   --form transaction_type=1
